import { Tooltip, TooltipPosition } from '@tableau/widgets';
import React from 'react';
import { classes, forceRenderStyles } from 'typestyle';

import { NavStyles } from './NavigationStyles';
import { NavListItemState } from './NavList';
import { NavPanelDisplayMode } from './NavPanel';

export interface NavListLinkProps extends NavListItemState {
  /** The url to navigate to when clicking this link */
  readonly href: string;
  /** Default icon image path for this link */
  readonly iconImagePath: string;
  /** The icon image path used when this link is selected, focused, or hovered */
  readonly activeIconImagePath: string;
  /** Localized text for this link */
  readonly name: string;
  /** Display mode for this link */
  readonly navPanelDisplayMode: NavPanelDisplayMode;
  /** Test Id for this link */
  readonly testId: string;
}

export class NavListLink extends React.PureComponent<NavListLinkProps, {}> {

  public render(): JSX.Element {
    const anchorClassName = NavStyles.NavLinkValue(this.props.iconImagePath, this.props.activeIconImagePath, this.props.selected);
    const iconClassName = classes('icon', this.props.navPanelDisplayMode === 'icon' ? NavStyles.NavIcon : NavStyles.NavIconByText);
    const textClassName = classes('text', NavStyles.NavLinkText);
    forceRenderStyles(); // flush the styles above to DOM right away to ensure correct height measurement in LeftNav::updateVerticalScrollState

    const anchor = (
      <a
        href={this.props.href}
        tabIndex={this.props.tabbable ? 0 : -1}
        className={anchorClassName}
        data-tb-test-id={this.props.testId}
        aria-label={this.props.name}
      >
        {this.props.selected &&
          <div data-tb-test-id='selected-bar' style={NavStyles.SelectedBarStyle}/>}
        <span className={iconClassName} />
        {this.props.navPanelDisplayMode === 'iconAndText' &&
          <div className={textClassName}>{this.props.name}</div>
        }
      </a>
    );

    return this.props.navPanelDisplayMode === 'icon'
      ? <Tooltip getContent={() => <span>{this.props.name}</span>} position={TooltipPosition.Right} testId={this.props.testId+'-tooltip'}>
          {anchor}
        </Tooltip>
      : anchor;
  }
}
